import React from 'react';

export default function CTA() {
  return (
    <section
      className="py-24 relative text-white"
      style={{
        backgroundImage: 'url(/ambani/3.JPG)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-12">
          <p className="text-xs uppercase tracking-[0.4em] text-white/70 mb-6">
            By YPD Weddings
          </p>
          <h3 className="text-3xl md:text-4xl font-serif mb-6">Let’s Write Your Love Story Together</h3>
          <p className="text-sm text-white/80 mb-10 max-w-3xl mx-auto">
            Tell us the beginning, and we’ll craft the magical chapters that follow.
          </p>
          <button className="px-8 py-3 border border-white text-white uppercase tracking-[0.3em] text-[10px]">
            Schedule a Consultation
          </button>
        </div>
      </div>
    </section>
  );
}
